import axios from "axios";
//element-plus 组件库引入
import { ElMessage } from 'element-plus'
import router from "../router";
const service = axios.create({
  baseURL: "http://shaobingshangbao.yuqing.pro/sentinel", //正式
  // baseURL: "http://test.shaobingshangbao.yuqing.pro/sentinel", //测试
});
service.all = axios.all;
service.interceptors.request.use(
  function (config) {
    // 一般在这个位置判断token是否存在
    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);
//响应拦截
service.interceptors.response.use(
  function (response) {
    if (response.data.code === 401) {
      router.push({
        path: "/login"
      });
      ElMessage({
        message: '登录已失效,请重新登录',
        type: "warning",
      });
      // sessionStorage.clear();
    }
    else if (response.data.code === 500) {
      console.log(response);
      ElMessage({
        message: response.data.msg,
        type: "warning",
      });
      // sessionStorage.clear();
    }
    else {
      return response.data;
    }
    // return response.data;
  },
  function (error) {
    // 处理响应失败
    return Promise.reject(error);
  }
);
export default service;
